var exports = {
  "O": "x234b8571--c861d5--group",
};

module.exports = exports;
